import { render, staticRenderFns } from "./consulting.vue?vue&type=template&id=34f5f9bc&scoped=true"
import script from "./consulting.vue?vue&type=script&lang=js"
export * from "./consulting.vue?vue&type=script&lang=js"
import style0 from "./consulting.vue?vue&type=style&index=0&id=34f5f9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5f9bc",
  null
  
)

export default component.exports